export { default } from "./BannerNotice-component";
